"use strict";exports.ICON_FILL_RULES={NONZERO:"nonzero",EVENODD:"evenodd"},exports.ICON_ROLES={APPLICATION:"application",DOCUMENT:"document",IMG:"img",PRESENTATION:"presentation"};
